<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
    <a [routerLink]="['/tasks/library']">Compliance Certificate</a>
  </li>
  <li>
    {{pageTitle}}
  </li>
</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>{{pageTitle}}</strong>
    </span>

    <button type="button" class="btn btn-sm btn-default pull-right btn-back" (click)="back()">
      <em class="fa fa-chevron-circle-left"></em>Back
    </button>

  </div>
  <div class="card-block">
    <div class="row">
      <div class="col-lg-12">

        <div class="margin-bottom-50">
          <form [formGroup]="complianceCertificateForm" class="well">
            <div class="modal-content">

              <div class="modal-body">
                <div class="row">

                  <div class="col-md-2">
                    <label class="form-control-label" for="l0">Certificate Name
                      <span _ngcontent-c2="" style="color: red;">*</span>
                    </label>
                  </div>
                  <div class="col-md-10">
                    <div class="form-group">
                      <input id="CertificateName" [formControl]="complianceCertificateForm.controls['CertificateName']"
                        class="form-control">
                      <div
                        *ngIf="(complianceCertificateForm.controls['CertificateName'].hasError('required') || complianceCertificateForm.controls['CertificateName'].hasError('whitespace')) && complianceCertificateForm.controls['CertificateName'].dirty"
                        class="form-control-error-custom">
                        The certificate name is required.
                      </div>

                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-control-label">Individual OR Branch / Department
                      <span _ngcontent-c2="" style="color: red;">*</span>
                    </label>
                  </div>
                  <div class="col-md-8">
                    <div class="form-group">
                      <div class="md-radio md-radio-inline">
                        <input id="certificateForYes" type="radio"
                          [formControl]="complianceCertificateForm.controls['certificateFor']" style="position:absolute"
                          name="certificateFor" value="Individual" class="form-check-input" disabled>
                        <label for="certificateForYes">Individual</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="certificateForNo" type="radio"
                          [formControl]="complianceCertificateForm.controls['certificateFor']" style="position:absolute"
                          name="certificateFor" value="Particular" class="form-check-input" disabled>
                        <label for="certificateForNo">Particular Branch / Department</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="certificateForYes1" type="radio"
                          [formControl]="complianceCertificateForm.controls['certificateFor']" style="position:absolute"
                          name="certificateFor" value="All" class="form-check-input" disabled>
                        <label for="certificateForYes1">All Branch / Department</label>
                      </div>
                      <div
                        *ngIf="complianceCertificateForm.controls['certificateFor'].hasError('required')&& complianceCertificateForm.controls['certificateFor'].dirty"
                        class="form-control-error-custom">
                        The Individual OR Branch / Department selection is required.
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2" *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                    <label class="form-control-label" for="l0">Department Name</label>
                  </div>
                  <div class="col-md-4" *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                    <div class="form-group">
                      <select [formControl]="complianceCertificateForm.controls['departmentId']"
                        class="form-control select" disabled>
                        <option value="">Select</option>
                        <option *ngFor="let dept of departmentList" value={{dept._id}}>
                          {{dept.DepartmentName}}
                        </option>
                      </select>
                    </div>


                  </div>

                  <div class="col-md-2" *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                    <label class="form-control-label" for="l0">Branch Name</label>
                  </div>
                  <div class="col-md-4" *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                    <div class="form-group">
                      <select [formControl]="complianceCertificateForm.controls['branchId']" class="form-control select"
                        disabled>
                        <option value="">Select</option>
                        <option *ngFor="let branch of branchList" value={{branch._id}}>
                          {{branch.BranchName}}
                        </option>
                      </select>
                    </div>

                    <!-- <div class="form-group"
                      *ngIf="complianceCertificateForm.controls.certificateFor.value == 'All'">
                      <button class="btn btn-sm btn-primary pull-left" data-toggle="modal"
                        (click)="showSelectedBranch()" data-target="#selectBranchDialog">Select Branch</button>
                    </div>
                    <div class="form-group"
                      *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Individual'">
                      <button class="btn btn-sm btn-primary pull-left" data-toggle="modal"
                        (click)="showSelectedBranch()" data-target="#selectBranchDialog">Select Users From Branch</button>
                    </div> -->
                  </div>
                  <div class="col-md-2" *ngIf="showAddedDept">Selected Departments :</div>
                  <div class="col-md-4" *ngIf="showAddedDept">
                    <ul>
                      <li *ngFor="let data of selectedIndividualDeptList">{{data.DepartmentID + "-" +
                        data.DepartmentName}}</li>
                    </ul>

                  </div>

                  <div class="col-md-2" *ngIf="showAddedBranch">Selected Branches :</div>
                  <div class="col-md-4" *ngIf="showAddedBranch">
                    <ul>
                      <li *ngFor="let data of selectedIndividualBranchList">{{data.BranchID + "-" + data.BranchName}}
                      </li>
                    </ul>
                  </div>


                  <div class="col-md-2" *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                    <label class="form-control-label" for="l0">Submitted By</label>
                  </div>
                  <div class="col-md-4" *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                    <select [formControl]="complianceCertificateForm.controls['submittedBy']"
                      class="form-control select"
                      (change)="setDefaultEscalation(complianceCertificateForm.controls.submittedBy.value, complianceCertificateForm.controls.certificateFor.value)">
                      <option value="">Select</option>
                      <option *ngFor="let user of userList" value={{user._id}}>
                        {{user.FirstName + " "+ user.LastName}}
                      </option>
                    </select>
                  </div>


                  <div class="col-md-2"
                    *ngIf="complianceCertificateForm.controls.certificateFor.value == 'All' || complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                    <label class="form-control-label" for="l0">Authorizer</label>
                  </div>
                  <div class="col-md-4" *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                    <select [formControl]="complianceCertificateForm.controls['authorizeBy']"
                      class="form-control select">
                      <option value="">Select</option>
                      <option *ngFor="let user of userList" value={{user._id}}>
                        {{user.FirstName + " "+ user.LastName}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4" *ngIf="complianceCertificateForm.controls.certificateFor.value == 'All'">
                    <div class="form-group">

                      <div class="md-radio md-radio-inline">
                        <input id="authRequired" type="radio"
                          [formControl]="complianceCertificateForm.controls['authorizationRequired']"
                          style="position:absolute" name="certificateFor" value="Yes" class="form-check-input">
                        <label for="authRequired">Required</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="authNotRequired" type="radio"
                          [formControl]="complianceCertificateForm.controls['authorizationRequired']"
                          style="position:absolute" name="certificateFor" value="No" class="form-check-input">
                        <label for="authNotRequired">Not Required</label>
                      </div>
                    </div>
                  </div>
                  <!-- &nbsp;&nbsp;&nbsp; -->

                  &nbsp;&nbsp;&nbsp;

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">
                            <label class="form-control-label" for="l0">Periodicity
                              <span _ngcontent-c2="" style="color: red;">*</span>
                            </label>
                          </div>
                          <div class="col-md-8">
                            <div class="form-group">
                              <select [formControl]="complianceCertificateForm.controls['periodicityId']"
                                class="form-control select">
                                <option value="">Select</option>
                                <option *ngFor="let data of periodicityData" value={{data._id}}>
                                  {{data.Name}}
                                </option>
                              </select>
                              <div
                                *ngIf="complianceCertificateForm.controls['periodicityId'].hasError('required') && complianceCertificateForm.controls['periodicityId'].dirty"
                                class="form-control-error-custom">
                                Periodicity is required.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">
                            <label class="form-control-label" for="l0">Due Days </label>
                          </div>
                          <div class="col-md-8">
                            <div class="form-group">
                              <input [formControl]="complianceCertificateForm.controls['dueDays']" class="form-control"
                                [OnlyNumber]=true (input)="checkRemindersValidation()">
                              <div
                                *ngIf="complianceCertificateForm.controls['dueDays'].hasError('min') && complianceCertificateForm.controls['dueDays'].dirty"
                                class="form-control-error-custom">
                                Due days cannot be negative.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>


                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">
                            <label class="form-control-label" for="l0">Activation From Date
                              <span _ngcontent-c2="" style="color: red;">*</span>
                            </label>
                          </div>
                          <div class="col-md-8">
                            <div class="form-group">
                              <div class="input-group" (click)="$event.stopPropagation()">
                                <app-datepicker-material
                                  [formControl]="complianceCertificateForm.controls['ActivationFromDate']"
                                  [(ngModel)]="ActivationFromDateModel" [placeholder]="'dd-mm-yyyy'"
                                  [minDate]="todaysDate" [disabled]="true"
                                  (ngModelChange)="onActivationFromDateChange()">
                                </app-datepicker-material>

                              </div>

                              <div
                                *ngIf="complianceCertificateForm.controls['ActivationFromDate'].hasError('required') && complianceCertificateForm.controls['ActivationFromDate'].dirty"
                                class="form-control-error-custom">
                                Periodicity is required.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">
                            <label class="form-control-label" for="l0">Activation Till Date</label>
                          </div>
                          <div class="col-md-8">
                            <div class="form-group">
                              <div class="input-group" (click)="$event.stopPropagation()">
                                <app-datepicker-material
                                  [formControl]="complianceCertificateForm.controls['activationTillDate']"
                                  [(ngModel)]="ActivationTillDateModel" [placeholder]="'dd-mm-yyyy'"
                                  [minDate]="ActivationFromDateModel" [disabled]="false"
                                  (ngModelChange)="onActivationTillDateChange()">
                                </app-datepicker-material>


                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="panel-group">
                      <div class="panel panel-primary panel-highlighted">

                        <div class="panel-body">
                          <div class="row">
                            <div class="col-md-2">
                              <label class="form-control-label" for="l0">Reminder Start (in days)
                                <span _ngcontent-c2="" style="color: red;">*</span>
                              </label>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <input [formControl]="complianceCertificateForm.controls['ReminderDays']"
                                  class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                                <div
                                  *ngIf="complianceCertificateForm.controls['ReminderDays'].hasError('required') && complianceCertificateForm.controls['ReminderDays'].dirty"
                                  class="form-control-error-custom">
                                  Reminder Start (in days) is required.
                                </div>
                                <div
                                  *ngIf="complianceCertificateForm.controls['ReminderDays'].hasError('min') && complianceCertificateForm.controls['ReminderDays'].dirty"
                                  class="form-control-error-custom">
                                  Reminder Start (in days) cannot be negative.
                                </div>
                              </div>
                            </div>

                            <div class="col-md-2">
                              <label class="form-control-label" for="l0">Reminder Frequency (days)
                                <span _ngcontent-c2="" style="color: red;">*</span>
                              </label>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <input [formControl]="complianceCertificateForm.controls['ReminderFrequency']"
                                  class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                                <div
                                  *ngIf="complianceCertificateForm.controls['ReminderFrequency'].hasError('required') && complianceCertificateForm.controls['ReminderFrequency'].dirty"
                                  class="form-control-error-custom">
                                  Reminder Frequency (in days) is required.
                                </div>
                                <div
                                  *ngIf="complianceCertificateForm.controls['ReminderFrequency'].hasError('min') && complianceCertificateForm.controls['ReminderFrequency'].dirty"
                                  class="form-control-error-custom">
                                  Reminder Frequency (days) cannot be negative.
                                </div>
                                <div id="ErrorreminderFrequency" *ngIf="reminderFrequencyError.isError"
                                  style="color: #fb434a;font-size: 80%;z-index: 1;">
                                  {{ reminderFrequencyError.errorMessage }}
                                </div>
                              </div>
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>

                  </div>

                  &nbsp;&nbsp;&nbsp;
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="panel-group">
                          <div class="panel panel-primary panel-highlighted" style="margin: 0px;">

                            <div class="panel-body">
                              <div class="row">

                                <div class="col-md-4"
                                  *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                                  <label class="form-control-label" for="l0">Report Recipient (Escalation 1)</label>
                                </div>
                                <div class="col-md-8"
                                  *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                                  <div class="form-group">

                                    <ng-select *ngIf="showEsc1Select" placeholder="Select User"
                                      class="form-control m-b-10 p-8" [multiple]=true
                                      (selected)="onChange($event,'Escalation1')"
                                      [formControl]="complianceCertificateForm.controls['Escalation1ofAssignedTo']"
                                      (deselected)="onChange($event,'Escalation1')" [options]="escalation1Users"
                                      style="padding: 0px; text-align:left;">
                                    </ng-select>
                                    <input [formControl]="complianceCertificateForm.controls['Escalation1Email']"
                                      class="form-control" *ngIf="showEsc1Text" disabled>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <label class="form-control-label" for="l0">Escalation 1 Reminder start date
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                  </label>
                                </div>
                                <div class="col-md-8">
                                  <div class="form-group">
                                    <input [formControl]="complianceCertificateForm.controls['EscalationDays']"
                                      class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                                    <div
                                      *ngIf="complianceCertificateForm.controls['EscalationDays'].hasError('required') && complianceCertificateForm.controls['EscalationDays'].dirty"
                                      class="form-control-error-custom">
                                      1st Escalation Start (in days) is required.
                                    </div>
                                    <div
                                      *ngIf="complianceCertificateForm.controls['EscalationDays'].hasError('min') && complianceCertificateForm.controls['EscalationDays'].dirty"
                                      class="form-control-error-custom">
                                      1st Escalation Start cannot be negative.
                                    </div>
                                    <div id="ErrorfirstEscalationStart" *ngIf="firstEscalationStartError.isError"
                                      style="color: #fb434a;font-size: 80%;z-index: 1;">
                                      {{ firstEscalationStartError.errorMessage }}
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <label class="form-control-label" for="l0">Escalation 1 Reminder frequency
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                  </label>
                                </div>
                                <div class="col-md-8">
                                  <div class="form-group">
                                    <input [formControl]="complianceCertificateForm.controls['ReminderFrequencyLevel1']"
                                      class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                                    <div
                                      *ngIf="complianceCertificateForm.controls['ReminderFrequencyLevel1'].hasError('required') && complianceCertificateForm.controls['ReminderFrequencyLevel1'].dirty"
                                      class="form-control-error-custom">
                                      Reminder Frequency (in days) is required.
                                    </div>
                                    <div
                                      *ngIf="complianceCertificateForm.controls['ReminderFrequencyLevel1'].hasError('min') && complianceCertificateForm.controls['ReminderFrequencyLevel1'].dirty"
                                      class="form-control-error-custom">
                                      1st Escalation reminder frequency cannot be negative.
                                    </div>

                                    <div id="ErrorfirstEscalationreminderFrequency"
                                      *ngIf="firstEscalationreminderFrequencyError.isError"
                                      style="color: #fb434a;font-size: 80%;z-index: 1;">
                                      {{ firstEscalationreminderFrequencyError.errorMessage }}
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="panel-group">
                          <div class="panel panel-primary panel-highlighted" style="margin: 0px;">

                            <div class="panel-body">
                              <div class="row">
                                <div class="col-md-4"
                                  *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                                  <label class="form-control-label" for="l0">Escalation 2</label>
                                </div>
                                <div class="col-md-8"
                                  *ngIf="complianceCertificateForm.controls.certificateFor.value == 'Particular'">
                                  <div class="form-group">


                                    <ng-select *ngIf="showEsc2Select" placeholder="Select User"
                                      class="form-control m-b-10 p-8" [multiple]=true
                                      [formControl]="complianceCertificateForm.controls['Escalation2ofAssignedTo']"
                                      [options]="escalation2Users" style="padding: 0px; text-align:left;">
                                    </ng-select>

                                    <input [formControl]="complianceCertificateForm.controls['Escalation2Email']"
                                      class="form-control" *ngIf="showEsc2Text" disabled>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <label class="form-control-label" for="l0">Escalation 2 Reminder start date</label>
                                </div>
                                <div class="col-md-8">
                                  <div class="form-group">
                                    <input [formControl]="complianceCertificateForm.controls['Level2EscalationDays']"
                                      class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                                    <div
                                      *ngIf="complianceCertificateForm.controls['Level2EscalationDays'].hasError('min') && complianceCertificateForm.controls['Level2EscalationDays'].dirty"
                                      class="form-control-error-custom">
                                      2nd Escalation Start cannot be negative.
                                    </div>
                                    <div id="ErrorsecondEscalationStart" *ngIf="secondEscalationStartError.isError"
                                      style="color: #fb434a;font-size: 80%;z-index: 1;">
                                      {{ secondEscalationStartError.errorMessage }}
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <label class="form-control-label" for="l0">Escalation 2 Reminder frequency </label>
                                </div>
                                <div class="col-md-8">
                                  <div class="form-group">
                                    <input [formControl]="complianceCertificateForm.controls['ReminderFrequencyLevel2']"
                                      class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                                    <div
                                      *ngIf="complianceCertificateForm.controls['ReminderFrequencyLevel2'].hasError('min') && complianceCertificateForm.controls['ReminderFrequencyLevel2'].dirty"
                                      class="form-control-error-custom">
                                      2nd Escalation reminder frequency cannot be negative.
                                    </div>
                                    <div id="ErrorsecondEscalationreminderFrequency"
                                      *ngIf="secondEscalationreminderFrequencyError.isError"
                                      style="color: #fb434a;font-size: 80%;z-index: 1;">
                                      {{ secondEscalationreminderFrequencyError.errorMessage }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <div class="col-md-12">
                    <section class="panel panel-default">
                      <div class="panel-heading">
                        <h5 class="panel-title pull-left">Compliance Confirmation Item</h5>

                        <div class="clearfix"></div>
                      </div>
                      <div class="panel-body" style="padding: 10px 0;">
                        <div class="col-md-12" style="padding: 0">
                          <form [formGroup]="complianceItemForm" class="well">
                            <table datatable [dtOptions]="dtOptionsForComplianceItem"
                              [dtTrigger]="dtTriggerForComplianceItem"
                              class="table table-hover compact cell-border nowrap stripe" id="addedComplianceItemTable"
                              style="cursor: pointer;">
                              <caption></caption>
                              <thead>
                                <tr>
                                  <th scope="row" style="width: 30px;">Compliance Confirmation </th>
                                  <th scope="row" style="width: 23px;">Status</th>
                                  <th scope="row" style="width: 25px;">Upload File</th>
                                  <th scope="row" style="width: 20px;">Remarks</th>
                                  <th scope="row" style="width: 2px;">
                                    <span>Remove</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody formArrayName="complianceItemFormArray"
                                *ngFor="let Field of newFieldArray; let i = index;">
                                <tr [formGroupName]="i">
                                  <td tabindex="1" style="width: 30px;">{{Field.complianceName}}</td>
                                  <td tabindex="1" style="width: 23px;">
                                    <select formControlName="{{'completionStatus'}}"
                                      [(ngModel)]="Field.completionStatus" class="form-control select">
                                      <option value=""> Select </option>
                                      <option value="0">Yes</option>
                                      <option value="1">Partially Completed</option>
                                      <option value="2">Not Completed</option>
                                      <option value="3">Not Applicable</option>
                                    </select>
                                  </td>
                                  <td style="width:25px">
                                    <label class="input-group">
                                      <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true"
                                        [value]="Field.complianceItemDocument.IsAvailable == true ? Field.complianceItemDocument.FileOrignalName : 'File Not Available'">

                                      <span class="input-group-addon default"
                                        *ngIf="Field.complianceItemDocument  && Field.complianceItemDocument.FileOrignalName != 'File Not Available' && Field.complianceItemDocument.FileOrignalName != ''"
                                        (click)="downloadFile(Field.complianceItemDocument.DocumentManagementID)">
                                        <em class="fa fa-download"></em>
                                      </span>
                                      <span class="input-group-addon warning"
                                        (click)="initiateUploadAgendaDocs(Field, 'complianceItem')">
                                        <em class="fa fa-upload"></em>
                                      </span>

                                    </label>
                                  </td>
                                  <td tabindex="1" style="width: 20px;">
                                    <textarea formControlName="{{'remarks'}}" class="form-control"
                                      [(ngModel)]="Field.remarks"></textarea>
                                  </td>
                                  <td tabindex="4" style="width: 2px;">
                                    <button type="button" class="btn-sm btn btn-danger"
                                      (click)="removeComplianceItem(item._id)">
                                      <span class="fa fa-close"></span>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </form>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div class="col-md-12">
                    <div class="col-md-4">
                      <label class="col-form-label" for="l5">
                        <span>Upload Attachment
                          <span _ngcontent-c2="" style="color: red;">*</span>
                        </span>
                      </label>
                    </div>
                    <div class="col-md-8">
                      <label class="input-group">
                        <input data-toggle="tooltip" type="text" class="form-control" [disabled]="true"
                          [value]="complianceCertificateAttachment?.IsAvailable ? complianceCertificateAttachment?.FileOrignalName : 'File Not Available'">

                        <span class="input-group-addon default"
                          *ngIf="complianceCertificateAttachment?.FileOrignalName && complianceCertificateAttachment.FileOrignalName !== 'File Not Available'"
                          (click)="downloadFile(complianceCertificateAttachment.DocumentManagementID)">
                          <em class="fa fa-download"></em>
                        </span>
                        <span class="input-group-addon warning"
                          (click)="initiateUploadAgendaDocs(null, 'complianceCertificate')">
                          <em class="fa fa-upload"></em>
                        </span>

                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button id="btnsaveTask" type="button" class="btn btn-sm btn-primary" *ngIf="addOrUpdateBtn"
                  [disabled]="(!complianceCertificateForm.valid) || (selectedComplianceList.length == 0)"
                  (click)="addComplianceCertificate(false)"><em class="fa fa-save"></em>Save to
                  Library</button>

                <button id="btnsaveTask" type="button" class="btn btn-sm btn-primary" *ngIf="addOrUpdateBtn"
                  [disabled]="(!complianceCertificateForm.valid) || (selectedComplianceList.length == 0)"
                  (click)="addComplianceCertificate(true)"><em class="fa fa-save"></em>Save &
                  Activate</button>
                <!-- [disabled]="(!complianceCertificateForm.valid) || (selectedComplianceList.length == 0)" -->
                <button id="btnsaveTask" type="button" class="btn btn-sm btn-primary" *ngIf="!addOrUpdateBtn"
                  (click)="updateComplianceCertificate()"><em class="fa fa-save"></em>Update</button>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" id="resetConfirmation" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete"><i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to reset the form data?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="resetFormData()"><i
              class="fa fa-check"></i>Yes</button>
          <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal"><i class="fa fa-times"></i>No</button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade modal-size-medium" id="addMakerDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel">Users</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <em class="fa fa-times"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12" style="padding: 0">
            <table datatable [dtOptions]="dtOptionsForMaker" [dtTrigger]="dtTriggerForMaker"
              class="table table-hover compact cell-border nowrap stripe" id="makerTable" style="cursor: pointer;">
              <caption></caption>
              <thead>
                <tr>
                  <th scope="row" tabindex="1">
                    <div class="md-checkbox">
                      <input id="selectcheckboxall" class="md-checkbox" type="checkbox" [(ngModel)]="selectedAll"
                        (change)="checkIfAllSelected($event);" />
                      <label for="selectcheckboxall">&nbsp;</label>
                    </div>
                  </th>
                  <th scope="row">UserName</th>
                  <th scope="row">
                    <span
                      [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">Remove</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of userList; let count=index">
                  <td>
                    <div class="md-checkbox">
                      <input id="selectcheckbox{{count +1 }}" type="checkbox" [(ngModel)]="user.selectedMakerUser"
                        (change)="checkSelected($event, count, user._id, user);">
                      <label for="selectcheckbox{{count +1 }}">&nbsp;</label>
                    </div>
                  </td>
                  <td tabindex="1">{{user.FirstName + " " + user.LastName}}</td>

                  <td tabindex="4">
                    <button type="button" class="btn-sm btn btn-danger"
                      (click)="removeTaskFromAgendaList(user.Task_id,user.certificateFor)"
                      [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                      <span class="fa fa-close"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>


        </div>
        <div class="modal-footer">

          <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary" data-dismiss="modal"><em
              class="fa fa-save"></em>Save </button>

          <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="getUserList()"> <em
              class="fa fa-times"></em>Close</button>
        </div>
      </div>

    </div>
  </div>

  <div class="modal fade modal-size-medium" id="addCheckerDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel">Users</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <em class="fa fa-times"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12" style="padding: 0">
            <table datatable [dtOptions]="dtOptionsForMaker" [dtTrigger]="dtTriggerForMaker"
              class="table table-hover compact cell-border nowrap stripe" id="checkerTable" style="cursor: pointer;">
              <caption></caption>
              <thead>
                <tr>
                  <th scope="row" tabindex="1">
                    <div class="md-checkbox">
                      <input id="selectcheckboxall1" class="md-checkbox" type="checkbox"
                        [(ngModel)]="selectedAllChecker" (change)="checkIfAllSelectedChecker($event);" />
                      <label for="selectcheckboxall1">&nbsp;</label>
                    </div>
                  </th>
                  <th scope="row">UserName</th>
                  <th scope="row">
                    <span
                      [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">Remove</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of userList; let count=index">
                  <td>
                    <div class="md-checkbox">
                      <input id="selectcheckbox1{{count +1 }}" type="checkbox" [(ngModel)]="user.selectedCheckerUser"
                        (change)="checkSelectedChecker($event, count, user._id, user);">
                      <label for="selectcheckbox1{{count +1 }}">&nbsp;</label>
                    </div>
                  </td>
                  <td tabindex="1">{{user.FirstName + " " + user.LastName}}</td>

                  <td tabindex="4">
                    <button type="button" class="btn-sm btn btn-danger"
                      (click)="removeTaskFromAgendaList(user.Task_id,user.certificateFor)"
                      [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                      <span class="fa fa-close"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>


        </div>
        <div class="modal-footer">

          <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary" data-dismiss="modal"><em
              class="fa fa-save"></em>Save </button>

          <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="getUserList()"> <em
              class="fa fa-times"></em>Close</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="AddCompliancesDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel">
            <em class="fa fa-plus"></em>Compliance Item
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button"
            (click)="clearSelectedCompliance()">
            <em class="fa fa-times"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="card-block datatable-card-block">
            <div class="row">
              <div class="col-md-12">
                <div class="margin-bottom-50">
                  <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptionsForComplianceItemAdd"
                      [dtTrigger]="dtTriggerForComplianceItemAdd"
                      class="table table-hover compact cell-border nowrap stripe" id="categoryTablePopup"
                      style="cursor: pointer;">
                      <caption></caption>
                      <thead>
                        <tr>
                          <th scope="row" style="width: 10%;">
                            <div class="md-checkbox">
                              <input id="selectCategoryPopUpAll" type="checkbox"
                                (change)="checkIfAllComplianceSelected($event)">
                              <label for="selectCategoryPopUpAll">&nbsp;</label>
                            </div>
                          </th>
                          <th scope="row" style="width: 65%;">Compliance Confirmation</th>

                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let item of complianceItems;  let count=index">
                          <tr>
                            <td style="width: 10%;" class="category-list-action">
                              <div class="md-checkbox">
                                <input id="selectPopUpCategory{{count +1 }}" type="checkbox"
                                  [(ngModel)]="item.isSelected" [ngModelOptions]="{standalone: true}"
                                  (change)="checkSelectedCompliance($event,count,item._id,item)">
                                <label for="selectPopUpCategory{{count +1 }}">&nbsp;</label>
                              </div>
                            </td>
                            <td style="width: 65%;" tabindex="1">
                              {{item.complianceName }}
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button id="btnsaveAgenda" type="button" data-dismiss="modal" class="btn-sm btn btn-primary"
            [disabled]="selectedComplianceData.length == 0">
            <em class="fa fa-save"></em>Save
          </button>
          <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="clearSelectedCompliance()">
            <em class="fa fa-times"></em>Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal-size-large" id="selectDepartmentDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel">Departments</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <em class="fa fa-times"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12" style="padding: 0">
            <table datatable [dtOptions]="dtOptionsForDepartment" [dtTrigger]="dtTriggerForDepartment"
              class="table table-hover compact cell-border nowrap stripe" id="deptTable" style="cursor: pointer;">
              <caption></caption>
              <thead>
                <tr>
                  <th scope="row" tabindex="1">
                    <div class="md-checkbox">
                      <input id="selectcheckboxall2" class="md-checkbox" type="checkbox"
                        [(ngModel)]="selectedAllDepartments" (change)="selectAllDepts($event);" />
                      <label for="selectcheckboxall2">&nbsp;</label>
                    </div>
                  </th>
                  <th scope="row">Department ID</th>
                  <th scope="row">Department Name</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dept of departmentList; let count=index">
                  <td>
                    <div class="md-checkbox">
                      <input id="selectcheckbox2{{count +1 }}" type="checkbox" [(ngModel)]="dept.selectedDept"
                        (change)="selectIndividualDept($event, count, dept._id, dept);">
                      <label for="selectcheckbox2{{count +1 }}">&nbsp;</label>
                    </div>
                  </td>
                  <td tabindex="1">{{dept.DepartmentID}}</td>
                  <td tabindex="1">{{dept.DepartmentName}}</td>
                </tr>
              </tbody>
            </table>
          </div>


        </div>
        <div class="modal-footer">

          <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
            (click)="addDeptBranch('dept')"><em class="fa fa-save"></em>Save </button>

          <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="getUserList()"> <em
              class="fa fa-times"></em>Close</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal-size-large" id="selectBranchDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel">Branch</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <em class="fa fa-times"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12" style="padding: 0">
            <table datatable [dtOptions]="dtOptionsForBranch" [dtTrigger]="dtTriggerForBranch"
              class="table table-hover compact cell-border nowrap stripe" id="deptTable" style="cursor: pointer;">
              <caption></caption>
              <thead>
                <tr>
                  <th scope="row" tabindex="1">
                    <div class="md-checkbox">
                      <input id="selectcheckboxall3" class="md-checkbox" type="checkbox"
                        [(ngModel)]="selectedAllBranches" (change)="selectAllBranches($event);" />
                      <label for="selectcheckboxall3">&nbsp;</label>
                    </div>
                  </th>
                  <th scope="row">Branch ID</th>
                  <th scope="row">Branch Name</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let branch of branchList; let count=index">
                  <td>
                    <div class="md-checkbox">
                      <input id="selectcheckbox3{{count +1 }}" type="checkbox" [(ngModel)]="branch.selectedBranch"
                        (change)="selectIndividualBranch($event, count, branch._id, branch);">
                      <label for="selectcheckbox3{{count +1 }}">&nbsp;</label>
                    </div>
                  </td>
                  <td tabindex="1">{{branch.BranchID}}</td>
                  <td tabindex="1">{{branch.BranchName}}</td>
                </tr>
              </tbody>
            </table>
          </div>


        </div>
        <div class="modal-footer">

          <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
            (click)="addDeptBranch('branch')"><em class="fa fa-save"></em>Save </button>

          <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="getUserList()"> <em
              class="fa fa-times"></em>Close</button>
        </div>
      </div>
      <!-- </form> -->
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="agendaDocxUploadDialog" tabindex="-1" role="dialog"
    data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <em class="fa fa-upload"></em>
            <span> Upload Document</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <em class="fa fa-times"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4">
                <label class="col-form-label" for="l5">
                  <span>Document
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input type="file" class='form-control fileUpload'
                    accept=".xlsx, .xls, .csv, .jpg, .doc, .docx, .txt, .pdf, .ppt, .mp4, .zip"
                    (change)="complianceItemChangeEvent($event)" />
                  <span *ngIf="typeHasError" style="color: red">
                    This file is not allowed to upload.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button *ngIf="uploadBtnType == 'complianceItem'" id="saveAgendaDoc" type="button"
            class="btn-sm btn btn-primary" (click)="uploadAgendaDocFile($event, 'complianceItem')">
            <em class="fa fa-save"></em>Upload</button>
          <button *ngIf="uploadBtnType == 'complianceCertificate'" id="saveAgendaDoc" type="button"
            class="btn-sm btn btn-primary" (click)="uploadAgendaDocFile($event, 'complianceCertificate')">
            <em class="fa fa-save"></em>Upload</button>
          <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
            <em class="fa fa-times"></em>Close</button>
        </div>
      </div>
    </div>
  </div>

</section>
<app-alert></app-alert>